var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-container",class:[_vm.notification.type || '']},[_c('p',{staticClass:"notification-container-text"},[_vm._v(" "+_vm._s(_vm.notification?.message || "")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }